// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBMPlexSansItalic_8c4f1c', '__IBMPlexSansItalic_Fallback_8c4f1c'","fontWeight":400},"className":"__className_8c4f1c","variable":"__variable_8c4f1c"};